import React from 'react';
import {Video} from 'glamorous';

import video from './viska.mp4';

export default ({autoPlay, controls}) =>
  (<Video
    width="100%"
    src={video}
    autoPlay={autoPlay}
    controls={controls}
    loop
  />);



// WEBPACK FOOTER //
// ./src/pages/Landing/Video.js